import { NavLink, Outlet, useLocation } from 'react-router-dom';
import { useEffect, useState } from 'react';
import { Button } from '@/components/ui/button';
import { toast } from 'sonner';
import { flushQueue } from './syncQueue';

export default function PortalLayout({ user, onLogout }) {
 const [isOnline, setIsOnline] = useState(navigator.onLine);
 const [syncCount, setSyncCount] = useState(0);
 const location = useLocation();

 useEffect(() => {
 const online = () => setIsOnline(true);
 const offline = () => setIsOnline(false);
 window.addEventListener('online', online);
 window.addEventListener('offline', offline);
 return () => {
 window.removeEventListener('online', online);
 window.removeEventListener('offline', offline);
 };
 }, []);

 const doSync = async () => {
 if (!navigator.onLine) {
 toast.error('You are offline. Will retry when online.');
 return;
 }
 let done = 0;
 await flushQueue(() => setSyncCount(++done));
 toast.success('Sync complete');
 };

 return (
 <div className="min-h-screen bg-white/50">
 {/* Offline banner */}
 {!isOnline && (
 <div className="w-full bg-orange-600 text-white text-center py-1 text-sm">Offline mode: changes will sync when back online</div>
 )}

 <div className="flex">
 {/* Sidebar */}
 <aside className="w-64 bg-white/70 backdrop-blur-sm border-r h-screen sticky top-0 p-4">
 <div className="font-bold text-[#0F172A] mb-6">Contractor Portal</div>
 <nav className="flex flex-col gap-2">
 <NavLink className={({isActive}) => `px-3 py-2 rounded ${isActive ? 'bg-slate-100' : ''}`} to="/">Dashboard</NavLink>
 <NavLink className={({isActive}) => `px-3 py-2 rounded ${isActive ? 'bg-slate-100' : ''}`} to="/portal/tasks">Tasks</NavLink>
 <NavLink className={({isActive}) => `px-3 py-2 rounded ${isActive ? 'bg-slate-100' : ''}`} to="/progress-logs">Progress Logs</NavLink>
 <NavLink className={({isActive}) => `px-3 py-2 rounded ${isActive ? 'bg-slate-100' : ''}`} to="/portal/documents">Documents</NavLink>
 <NavLink className={({isActive}) => `px-3 py-2 rounded ${isActive ? 'bg-slate-100' : ''}`} to="/portal/settings">Settings</NavLink>
 </nav>
 <div className="mt-6">
 <Button className="w-full" onClick={doSync}>Sync Now</Button>
 </div>
 <div className="mt-2 text-xs text-[#94A3B8]">Synced items this session: {syncCount}</div>
 </aside>

 {/* Content */}
 <main className="flex-1 p-6">
 <Outlet />
 </main>
 </div>
 </div>
 );
}
